import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { User } from '../../user/User'
import { TaskStatusActionConfig } from '../task-action-hook/TaskStatusActionConfig'

/**
 * Input type for updating a task's status actions configuration.
 */
@InputType()
export class UpdateTaskStatusActionsArgs {
  /**
   * Filter to identify which task to update.
   * Typically contains the task _id.
   */
  @Field(() => GraphQLJSON)
  filter: Record<string, unknown>

  /**
   * Array of status action configurations to set on the task.
   * This replaces any existing statusActions on the task.
   */
  @Field(() => [TaskStatusActionConfig])
  statusActions: TaskStatusActionConfig[]

  /**
   * User performing the update.
   * Injected from context, not provided in GraphQL input.
   */
  user?: User
}
